import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, concatMap, delay, distinctUntilChanged, map, of } from 'rxjs';
import { AppRoutes } from 'src/app/app-routes';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';
import { DeviceStoreService } from 'src/app/services/device-store/device-store.service';
import { LoginService } from 'src/app/services/login-service/login-service.service';
import { RegisterService } from 'src/app/services/register-service/register.service';

@Component({
  selector: 'app-phone-confirm',
  templateUrl: './phone-confirm.component.html',
  styleUrls: ['./phone-confirm.component.scss']
})
export class PhoneConfirmComponent extends SubmittableForm implements OnInit, OnDestroy {
  
  faBack = faArrowLeft;
  AppRoutes = AppRoutes;

  private phoneNumberSubscription: Subscription | undefined;
  phoneNumber: string | undefined;
  resendDisabled = false;

  constructor(
    translateService: TranslateService,
    private loginService: LoginService,
    private router: Router,
    private registerService: RegisterService,
    private deviceStore: DeviceStoreService,
    private spinner: NgxSpinnerService
  ) 
  {
    super(translateService)
  }

  override form = new FormGroup({
    confirmationCode: new FormControl('', {
      validators: [Validators.required, Validators.pattern('[0-9]{4}')]
    })
  });

  ngOnInit(): void 
  { 
    
    this.phoneNumberSubscription = this.deviceStore.user.pipe(
      map(user => user && user.id),
      distinctUntilChanged(),
      concatMap(driverUserId => {
        if (driverUserId)
        {
          return this.loginService.driverManagementDetails(driverUserId).pipe(
            map(response => response.demographic && response.demographic.mobileTelNo)
          );
        }

        return of(undefined);
      }
      )
    ).subscribe(phoneNumber => {
      this.phoneNumber = phoneNumber;
    });
  }

  override ngOnDestroy(): void
  {
    super.ngOnDestroy();
    
    this.phoneNumberSubscription?.unsubscribe();
  }

  async onCodeSubmitted()
  {
    this.spinner.show();
    
    return super.onConfirm(
      () => { 
        return this.registerService.verify(this.form.value.confirmationCode as string);
      },
      {
        onSuccess: async () => {
          this.spinner.hide();

          this.router.navigate([AppRoutes.Details]);
        },
        onError: () => {
          this.spinner.hide();
        }
      }
    );
  }

  resendVerificationCode()
  {
    if (this.resendDisabled)
    {
      return;
    }
    this.resendDisabled = true;
    return this.registerService.resendVerificationCode().pipe(delay(500)).subscribe({
      complete: () => this.resendDisabled = false
    });
  }

  getIsResendDisabled() : boolean
  {
    return this.resendDisabled;
  }

  getUserTelNo() : string
  {
   return this.phoneNumber ? this.phoneNumber : '';
   
  }
}
